import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { apiClient } from 'core/http'
import { useWindowActions } from '../../../../models/window'
import { modalNames } from '../../constants/names'
import SheetModal from '../sheet-modal/sheet-modal'
import giftBox from '../../../friends/milestones/assets/images/gift-box.png'
import c from './game-select-modal.module.scss'

const GameSelectModal = ({ threshold, caseData, onClaimed }) => {
    const { t } = useTranslation()
    const { closeWindow, openWindow } = useWindowActions()
    const [loading, setLoading] = useState(false)

    const handleSelect = async (game) => {
        if (loading) return

        if (caseData) {
            closeWindow()
            setTimeout(() => {
                openWindow(modalNames.CASE_MODAL, {
                    caseData: { ...caseData, selectedGame: game },
                })
            }, 300)
            return
        }

        setLoading(true)
        try {
            const res = await apiClient.post(`/friends/milestones/${threshold}/claim`, { game })
            if (res?.data?.success) {
                if (onClaimed) onClaimed()
                closeWindow()
                setTimeout(() => {
                    openWindow(modalNames.CASE_MODAL, {
                        caseData: {
                            id: null,
                            name: res.data.caseName,
                            imageUrl: res.data.caseImage,
                            promoCode: res.data.promoCode,
                            isHistory: true,
                            price: 0,
                        },
                    })
                }, 300)
            }
        } catch (e) {
            const serverMsg = e?.response?.data?.error || ''
            const errorMap = {
                'Case not configured for this milestone': 'earnings.gameSelect.error.notConfigured',
                'Configured case not found': 'earnings.gameSelect.error.notConfigured',
                'No cases available': 'earnings.gameSelect.error.notConfigured',
                'Promo codes depleted': 'earnings.gameSelect.error.depleted',
                'Already claimed': 'earnings.gameSelect.error.alreadyClaimed',
                'Not enough friends': 'earnings.gameSelect.error.notEnoughFriends',
                'Invalid game': 'earnings.gameSelect.error.invalidGame',
            }
            const localized = errorMap[serverMsg]
            const msg = localized ? t(localized) : serverMsg || t('common.error')
            toast(msg, { type: 'error' })
            closeWindow()
        } finally {
            setLoading(false)
        }
    }

    return (
        <SheetModal>
            <div className={c.component}>
                <img className={c.image} src={giftBox} alt="" />
                <h3 className={c.title}>{t('earnings.gameSelect.title')}</h3>
                <p className={c.subtitle}>{t('earnings.gameSelect.subtitle')}</p>
                <div className={c.buttons}>
                    <button className={c.button} disabled={loading} onClick={() => handleSelect('STANDOFF_2')}>
                        {t('earnings.gameSelect.standoff')}
                    </button>
                    <button className={c.button} disabled={loading} onClick={() => handleSelect('PUBG_MOBILE')}>
                        {t('earnings.gameSelect.pubg')}
                    </button>
                </div>
            </div>
        </SheetModal>
    )
}

export default GameSelectModal
